import { Component } from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import IconButton from '@doveconviene/react-sf-ui/components/IconButton'
import Icon from '@doveconviene/react-sf-ui/components/Icon'

import { ReactComponent as PinIcon } from '@doveconviene/sf-ui/icons/pin_circle.svg'
import { fetchStores } from '../../redux/middlewares/api/stores'

import {
  PANEL_STORES,
  openPanel,
} from '../../redux/actions'
import { selectFlyerStores } from '../../redux/selectors'

import { env, getAppLayout } from '../../utils'
import { breakpoints } from '../../helpers/breakpoints'

const { hostname } = window.location
const layout = getAppLayout(hostname)

class FlyerStoresToggle extends Component {
  componentDidMount() {
    const { flyerId } = this.props
    this.props.fetchStores(flyerId)
  }

  /**
   * Returns stores list if we go back
   * to previous flyer through browser arrow
   */
  componentDidUpdate(prevProps) {
    const { flyerId } = this.props
    if (prevProps.flyerId !== flyerId) {
      this.props.fetchStores(flyerId)
    }
  }

  renderText() {
    const { client: { viewport } } = this.props
    const mediumBreakpoint = breakpoints.find(x => x.name === 'medium')
    const shallRender = viewport.width >= mediumBreakpoint.min
    return shallRender ? env('REACT_APP_STRING_STORES') : null
  }

  render() {
    const { stores, openPanelStores } = this.props
    return (stores && stores.length > 0) ? (
      <IconButton
        style={{ color: layout.storesCtaColor }}
        bgColor="transparent"
        size="large"
        onClick={openPanelStores}
      >
        <Icon>
          <PinIcon />
        </Icon>
        {this.renderText()}
      </IconButton>
    ) : null
  }
}

FlyerStoresToggle.propTypes = {
  flyerId: PropTypes.number.isRequired,
  stores: PropTypes.arrayOf(PropTypes.shape({})),
  fetchStores: PropTypes.func.isRequired,
  openPanelStores: PropTypes.func.isRequired,
  client: PropTypes.shape({
    viewport: PropTypes.shape({
      width: PropTypes.number,
    }),
  }).isRequired,
}

FlyerStoresToggle.defaultProps = {
  stores: [],
}

function mapStateToProps(state, ownProps) {
  const { client } = state
  return {
    stores: selectFlyerStores(ownProps.flyerId)(state),
    client,
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchStores,
    openPanelStores: () => openPanel(PANEL_STORES),
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(FlyerStoresToggle)
